<template>
  <div class="main-body margin_bottom" style="color: white">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <AdminChannelViewLayout></AdminChannelViewLayout>
    <hr class="bg-white" />
    <div class="container">
      <div class="row">
        <div
          class="col-12 col-md-2 col-lg-2 mb-3"
          v-for="(data, index) in AudiobookData"
          :key="index"
        >
          <div
            class="card bg-dark bg-transparent"
            v-on:click="navigate(data.id)"
            style="cursor: pointer"
          >
            <img
              class="card-img-top"
              :src="data.thumb_path"
              alt="Card image cap"
            />
            <div class="mt-2">
              <h5 class="card-title" style="font-size: 15px">
                {{ data.name }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import AdminChannelViewLayout from "../layouts/AdminChannelViewLayout"
export default {
  name: "ChannelDetails",
  components: {
    Loading, AdminChannelViewLayout
  },
  data() {
    return {
      channelId: this.$route.params.id,
      AudiobookData: [],
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  created(){
    localStorage.setItem('tempChannelId', this.channelId);
  },
  methods: {
    navigate(id) {
      console.log(id);
      this.$router.push("/audiobook/" + id);
    },
    async getAudioBookData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/audiobooks/all-by-channel-id" +
            "?channel_id=" +
            this.channelId,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.AudiobookData = res.data;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getAudioBookData();
  },
};
</script>
<style scoped>
@import "../../assets/css/channel.scss";
</style>